import axios from 'axios'
import { message } from 'antd';
import config from '@/config'
import { getProgramNameByDomain } from './util'

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

const patientBaseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.patientDev : config.baseUrl.patientPro

const patientAxios = axios.create({
  baseURL: patientBaseUrl
})

const getProgramName = () => {
  if (import.meta.env.VITE_ENV !== 'production') {
    return import.meta.env.VITE_APP_PROGRAM
  }
  return getProgramNameByDomain()
}

const requestInterceptors = (config) => {
  const program = getProgramName()
  config.headers.ProgramName = program
  config.headers.Authorization = localStorage.getItem('Authorization')

  return config
}

const requestError = (error) => {
  return Promise.reject(error)
}

// providers
axios.interceptors.request.use((config) => {
  const program = getProgramName()

  config.headers.ProgramName = program
  config.headers.Authorization = localStorage.getItem('Authorization')
  if (config.customHeaders) {
    config.headers = {
      ...config.headers,
      ...config.customHeaders
    }
  }
  return config
}, requestError);

// patient
patientAxios.interceptors.request.use((config) => {
  const program = getProgramName()
  config.headers.ProgramName = program
  config.headers.Authorization = localStorage.getItem('Authorization')

  return config
}, requestError);


const responseInterceptors = (response) => {
  return response.data
}

const responseError = (error) => {
  if (error.response) {
    if (error.config?.customError) {
      return Promise.reject(error.response);
    }

    const errorMessage = error.response.data.message;
    // Handle multi-line messages by taking first line
    const lastMessage = errorMessage?.includes('\n')
      ? errorMessage.split('\n')[0]
      : errorMessage;

    if (/^401$/.test(error.response.status)) {
      localStorage.setItem('Authorization', '');
      // window.location.href = "/"
      message.error(lastMessage, 5);
    } else if (/^4.*/.test(error.response.status)) {
      message.info(lastMessage, 5);
    } else {
      message.info(lastMessage, 5);
    }
  }
  return Promise.reject(error.response)
}

axios.interceptors.response.use(responseInterceptors, responseError)
patientAxios.interceptors.response.use(responseInterceptors, responseError)

export const post = (url, params, headers) => {
  return patientAxios.post(url, params, {
    ...headers
  })
}

export const get = (url) => {
  return patientAxios.get(url)
}